import React from 'react';
import skintightening from '../assets/skintightening.jpg';
import narilart from '../assets/narilart.jpg';
import hairservice1 from '../assets/hairservice1.jpg';
import eyelash from '../assets/eyelash.jpg';

const MeettheTeam = () => {
  return (
    <>
     <div className="container py-">
    <h1 className="text-center " style={{ color: '#b37777', fontStyle: 'italic', fontFamily: "'TAN TWINKLE', cursive" }}>Meet the Team</h1>
    <p className="text-center mb-5">
        Our talented team of nail artists and estheticians is here to bring your vision to life. 
        From bold nail art to flawless skincare, we’re dedicated to exceeding your expectations.
    </p>
<center>
    <div className="row g-4">
        <div className="col-md-3 ">
        <div className="card img-fluid text-center" style={{width: "300px" , padding:"0px"}}>
        <img src={skintightening} className="card-img-top" style={{ maxHeight: '300px' }} alt="Esthetician performing skincare treatments" />
                <div className="card-body">
                    <h5 className="card-title">Name</h5>
                    <p className="card-text">Esthetician</p>
                </div>
            </div>
        </div>

        <div className="col-md-3 ">
        <div className="card img-fluid text-center" style={{width: "300px" , padding:"0px"}}>
                <img src={narilart} className="card-img-top" style={{ maxHeight: '300px' }} alt="Nail technician creating unique nail art" />
                <div className="card-body">
                    <h5 className="card-title">Name</h5>
                    <p className="card-text">Nail Technician</p>
                </div>
            </div>
        </div>

        <div className="col-md-3 ">
        <div className="card img-fluid text-center" style={{width: "300px" , padding:"0px"}}>
                <img src={hairservice1} className="card-img-top" style={{ maxHeight: '300px' }} alt="Hair stylist working on a client's hairstyle" />
                <div className="card-body">
                    <h5 className="card-title">Name</h5>
                    <p className="card-text">Hair Stylist</p>
                </div>
            </div>
        </div>

        <div className="col-md-3 " >
        <div className="card img-fluid text-center" style={{width: "300px" , padding:"0px"}}>
                <img src={eyelash} className="card-img-top" style={{ maxHeight: '300px' }} alt="Eyebrow technician enhancing brows with precision" />
                <div className="card-body">
                    <h5 className="card-title">Name</h5>
                    <p className="card-text">Eyebrow Technician</p>
                </div>
            </div>
        </div>
        
    </div></center>
</div>
    </>
  );
};

export default MeettheTeam;
